import actions from "@/store/faq/actions";
import state from "@/store/faq/states";
import mutations from "@/store/faq/mutations";

const FaqModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default FaqModule;